import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { SessionCfg } from "src/app/models/models";
import { splitSessionsIntoColumns } from "../ts1-form.factories";
import { Ts1SessionRemarkModalComponent } from "../ts1-session-remark-modal/ts1-session-remark-modal.component";

@Component({
	selector: "app-ts1-session-config",
	templateUrl: "./ts1-session-config.component.html",
	styleUrls: ["./ts1-session-config.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class Ts1SessionConfigComponent {
	@Input({ required: true }) sessions!: UntypedFormGroup;
	@Input({ required: true }) sessionRemarks!: UntypedFormGroup;
	@Input({ required: true }) columns: SessionCfg[][] = [];
	@Input() readOnly = false;

	searchQuery = "";

	get filteredColumns(): SessionCfg[][] {
		const query = this.searchQuery.trim().toLowerCase();
		if (!query) return this.columns;

		const filtered = this.columns.flat().filter((s) => {
			const description = (s.description ?? "").toLowerCase();
			const code = (s.code ?? "").toLowerCase();
			return description.includes(query) || code.includes(query);
		});

		return splitSessionsIntoColumns(filtered, 4);
	}

	isSelected(code: string): boolean {
		return this.sessions.get(code)?.value === true;
	}

	getRemarkPreview(code: string): string {
		const value = (this.sessionRemarks.get(code)?.value ?? "").toString().trim();
		if (!value) return "";
		return value.length > 20 ? `${value.slice(0, 20)}…` : value;
	}

	openRemarkEditor(session: SessionCfg): void {
		if (this.readOnly) return;
		const dialogRef = this.dialog.open(Ts1SessionRemarkModalComponent, {
			panelClass: ["ts1-session-remark-modal-panel", "ts1-session-remark-modal"],
			width: "720px",
			hasBackdrop: true,
			data: {
				sessionLabel: session.description,
				value: (this.sessionRemarks.get(session.code)?.value ?? "").toString(),
			},
		});

		dialogRef.afterClosed().subscribe((result: string | null) => {
			if (result === null) return;
			const ctrl = this.sessionRemarks.get(session.code) as UntypedFormControl | null;
			ctrl?.setValue(result);
			ctrl?.markAsDirty();
		});
	}

	constructor(private dialog: MatDialog) {}
}
